import React, { useEffect, useState } from 'react'
import * as S from './LegendStyles'
import { AlertsLegendItem } from 'types/RuntimeHistory'
import { SelectedLegends } from '.'
import { Alert } from 'types/Alert'

type AlertFiltersProps = {
  alerts: Array<Alert>;
  selectedLegends: SelectedLegends;
  onAlertsSelectionChanged: (seriesName: string) => void;
}

const ALERTS_LEGEND_ITEMS: ReadonlyArray<AlertsLegendItem> = Object.freeze([
  Object.freeze({ label: 'Critical', seriesName: 'critical' }),
  Object.freeze({ label: 'Major', seriesName: 'major' }),
  Object.freeze({ label: 'Minor', seriesName: 'minor' }),
  Object.freeze({ label: 'Major SDAs', seriesName: 'major-sda' }),
  Object.freeze({ label: 'Minor SDAs', seriesName: 'minor-sda' }),
  Object.freeze({ label: 'Dirty Air Filter', seriesName: 'dirty-filter' })
])

const AlertFilters = ({ alerts, selectedLegends, onAlertsSelectionChanged }: AlertFiltersProps) => {
  const [parsedAlertLegendItems, setParsedAlertLegendItems] = useState<
    ReadonlyArray<AlertsLegendItem>
  >([])

  useEffect(() => {
    const newAlertLegendItems = structuredClone(ALERTS_LEGEND_ITEMS)
    const severityCounts = alerts?.reduce((counts, alert) => {
      counts[alert.severity] = (counts[alert.severity] || 0) + 1
      return counts
    }, {})

    newAlertLegendItems.forEach(legendItem => {
      const count = severityCounts[legendItem.seriesName] || 0
      legendItem.label = `${legendItem.label.split('(')[0].trim()} (${count})`
      legendItem.emptyDataSet = count === 0
    })

    setParsedAlertLegendItems(newAlertLegendItems)
  }, [alerts])

  return (
    <S.ListGroup direction="column">
      <S.Typography marginBottom={10}>Alerts</S.Typography>
      <S.CheckboxGroup gap={2}>
        {parsedAlertLegendItems.map(legendItem => (
          <S.FilterCheckbox
            key={legendItem.seriesName}
            label={legendItem.label}
            listId="alerts"
            checked={selectedLegends.alerts?.includes(legendItem.seriesName)}
            autoWidth
            onChange={() => onAlertsSelectionChanged(legendItem.seriesName)}
          />
        ))}
      </S.CheckboxGroup>
    </S.ListGroup>
  )
}

export default AlertFilters
